<!--Dialog-->
<div mat-dialog-title> Hilfeseite bearbeiten </div>

<div mat-dialog-content>
    <!--    Titel-->
    <mat-form-field style="width: 100%">
        <mat-label>Titel</mat-label>
        <input matInput type="text" [formControl]="titelCtrl" (change)="setTitel()" />
    </mat-form-field>
    <!--    Rollen-->
    <mat-form-field style="width: 100%">
        <mat-label>Hilfe für Benutzerrollen freigeben</mat-label>
        <mat-select
            multiple
            [formControl]="benutzerrollenCtrl"
            (selectionChange)="setRollen($event)"
            [compareWith]="compareRoles"
        >
            <mat-option *ngFor="let r of roles" [value]="r">
                {{ r.bezeichnung }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <!--    Url-->
    <mat-form-field style="width: 100%">
        <mat-label>Hilfeseite - URL</mat-label>
        <input type="text" matInput [formControl]="hilfeseiteUrlCtrl" (change)="setUrl()" />
    </mat-form-field>
</div>

<div mat-dialog-actions>
    <button mat-button (click)="deleteHilfeReiter()" color="warn" *ngIf="hilfereiter.hr_id">Löschen</button>
    <span class="spacer"></span>
    <button mat-button (click)="close()">Schließen</button>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isDisabled()">Speichern</button>
</div>
